import { Box, Tooltip, Typography } from '@mui/material'

/**
 * Compact prescription-section header: a small square icon + title, with the section's
 * one-line description tucked into a hover tooltip (instead of an always-visible caption),
 * and an optional right-side slot for per-section controls (undo/redo, print toggle).
 * Keeps the section cards lean and consistent.
 */
export default function LeanSectionHeader({ icon, title, description, rightSlot, accentColor = '#4338ca' }) {
  const titleGroup = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        minWidth: 0,
        cursor: description ? 'help' : 'default',
      }}
    >
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: '7px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: `${accentColor}14`,
          color: accentColor,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Typography
        component="span"
        sx={{
          fontWeight: 700,
          color: '#1e293b',
          fontSize: 16,
          lineHeight: 1.2,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {title}
      </Typography>
    </Box>
  )

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mb: 1.5,
        pb: 1,
        borderBottom: '1px solid rgba(15, 23, 42, 0.06)',
      }}
    >
      {description ? (
        <Tooltip title={description} arrow placement="top">
          {titleGroup}
        </Tooltip>
      ) : (
        titleGroup
      )}
      {rightSlot ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>{rightSlot}</Box>
      ) : null}
    </Box>
  )
}
